export default __webpack_public_path__ + "static/media/pilz-14.d1083f31.png";